import React, { useState, useEffect } from "react";
// import Preloader from "../src/components/Pre";
// import Navbar from "./components/navbar/Navbar";
import Home from "./components/Home/Home";

import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Preloader from "./components/Preloader/Preloader";
import NavBar from "./components/navbar/navb";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/footer/Footer";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
          
      <Preloader load={load} />

      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />

        </Routes>
        <Footer />


        {/* scroll to top */}

        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;
